import { jsx as _jsx } from "react/jsx-runtime";
import { HStack, Stack } from "@chakra-ui/react";
import Search from "./search";
const TableFilterPanel = ({ showSelects = false, searchTerm, handleChangeSearch, isInline = false, }) => (_jsx(Stack, Object.assign({ mt: isInline ? "0" : "6", spacing: "4", direction: { base: "column", md: "row" }, justify: "space-between" }, { children: _jsx(HStack, { children: _jsx(Search, { term: searchTerm, handleChangeSearch: handleChangeSearch }) }) })));
export default TableFilterPanel;
